import { render } from "./DynamicBlogDetails.vue?vue&type=template&id=6119bb8d"
import script from "./DynamicBlogDetails.vue?vue&type=script&lang=js"
export * from "./DynamicBlogDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__